import { render, staticRenderFns } from "./PerkIcon.vue?vue&type=template&id=4bff3be0&scoped=true&"
import script from "./PerkIcon.vue?vue&type=script&lang=js&"
export * from "./PerkIcon.vue?vue&type=script&lang=js&"
import style0 from "./PerkIcon.vue?vue&type=style&index=0&id=4bff3be0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bff3be0",
  null
  
)

export default component.exports